import order from '@/ajax/checkout/order';
import quick from '@/ajax/checkout/quick';

/**
 * @module ajaxAPI/checkout
 *
 * @description
 * Ajax-обертки для работы с оформлением заказа
 */

const checkout = {
  order,
  quick
};

export default checkout;
